import React from "react";
import { useNavigate } from "react-router-dom";
import '../termsServices/terms.css'

export default function Terms() {
     const navigate = useNavigate();
    return (
        <section class="terms-section py-5" id="terms-section">
            <div class="container">

                <div class="text-center mb-5">

                    <h2 class="terms-title fw-bold mb-4">
                        Terms & Conditions
                    </h2>

                    <p class="terms-subtitle w-75 m-auto mb-4">
                        Welcome to VOLT Learning Knowledge Quest. By registering for or participating in any assessment hosted on this platform, you agree to comply with the following Terms & Conditions.
                    </p>

                    <button
                        className="btn terms-back-btn"
                        onClick={() => navigate("/")}
                    >
                        ← Back to Home
                    </button>

                </div>

                <div class="row justify-content-center">
                    <div class="col-xl-9 col-lg-10">

                        <div class="terms-card mb-4">
                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Acceptance of Terms
                                    </h4>

                                    <p class="terms-text mb-0">
                                        By accessing or using the VOLT Learning Knowledge Quest platform, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.
                                    </p>

                                </div>

                            </div>
                        </div>

                        <div class="terms-card mb-4">
                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Eligibility
                                    </h4>

                                    <p class="terms-text mb-0">
                                        <ul className="">
                                            <li className="">Participation is open only to students meeting the eligibility criteria specified for the respective assessment.</li>
                                            <li className="">Participants must provide accurate and complete registration details.</li>
                                            <li className="">VOLT Learning reserves the right to reject or cancel any registration that contains incorrect, incomplete, or misleading information.</li>
                                        </ul>
                                    </p>

                                </div>

                            </div>
                        </div>

                        <div class="terms-card mb-4">
                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Registration
                                    </h4>

                                    <p class="terms-text mb-0">
                                        <ul className="">
                                            <li className="">Registration is considered complete only after successful payment (where applicable).</li>
                                            <li className="">Registration fees are non-transferable and non-refundable unless otherwise specified by VOLT Learning.</li>
                                            <li className="">Registration cannot be transferred to another participant.</li>
                                        </ul>
                                    </p>

                                </div>

                            </div>
                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3 w-100">

                                    <h4 class="terms-card-title mb-2">
                                        Assessment Rules
                                    </h4>
                                    <p className="">
                                        Participants must:<br></br><br></br>
                                        <ul class="terms-list mb-0">
                                            <li>Attempt the assessment independently.</li>
                                            <li>Complete the assessment within the allotted time.</li>
                                            <li className="">Use only permitted resources, if any are specified.</li>
                                            <li className="">Follow all instructions provided before and during the assessment.</li>
                                        </ul><br></br>
                                        VOLT Learning reserves the right to disqualify any participant found violating these rules.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3 w-100">

                                    <h4 class="terms-card-title mb-3">
                                        Fair Participation
                                    </h4>
                                    <p className="">
                                        Any attempt to gain an unfair advantage, including but not limited to:<br></br><br></br>
                                        <ul class="terms-list">
                                            <li>impersonation,</li>
                                            <li>use of unauthorized assistance,</li>
                                            <li>copying or sharing assessment content,</li>
                                            <li>multiple registrations for the same participant,</li>
                                            <li>tampering with the platform,</li>
                                        </ul><br></br>
                                        may result in immediate disqualification without prior notice.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">


                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Assessment Schedule
                                    </h4>

                                    <p className="">
                                        Assessment dates and timings may be changed, postponed, or cancelled due to technical, administrative, or unforeseen circumstances.<br></br>
                                        VOLT Learning reserves the right to modify the schedule without prior notice.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3 w-100">

                                    <h4 class="terms-card-title mb-2">
                                        Technical Requirements
                                    </h4>

                                    <p class="terms-text">
                                        Participants are responsible for:<br></br><br></br>
                                        <ul className="">
                                            <li className="">arranging a suitable device,</li>
                                            <li className="">maintaining a stable internet connection,</li>
                                            <li className="">ensuring browser compatibility,</li>
                                            <li className="">completing the assessment within the scheduled window.</li>
                                            VOLT Learning shall not be responsible for interruptions caused by participant-side internet, hardware, software, or power failures.
                                        </ul>
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Results & Recognition
                                    </h4>

                                    <ul class="terms-list mb-0">
                                        <li>Results will be declared after evaluation.</li>
                                        <li>Recognition and rewards are subject to verification of participant details.</li>
                                        <li>VOLT Learning reserves the right to withhold, modify, or cancel any reward if eligibility criteria are not met.</li>
                                    </ul>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Certificates
                                    </h4>
                                    <p className="">
                                        Participation certificates will be issued only to eligible participants who successfully complete the assessment in accordance with these Terms & Conditions.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Intellectual Property
                                    </h4>

                                    <p className="">
                                        All assessment content, questions, graphics, logos, designs, downloadable materials, videos, and other resources available on the platform are the exclusive intellectual property of VOLT Learning or its licensors.<br></br>
                                        No content may be copied, reproduced, distributed, published, modified, or shared without prior written permission.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Privacy
                                    </h4>

                                    <p className="">
                                        Participant information will be used only for registration, assessment administration, result processing, communication, and other educational purposes in accordance with the Privacy Policy.
                                        VOLT Learning will not knowingly sell personal information to third parties.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Platform Availability
                                    </h4>

                                    <p className="">
                                        While every effort is made to ensure uninterrupted service, VOLT Learning does not guarantee continuous availability of the platform.
                                        Temporary interruptions due to maintenance, upgrades, technical issues, or unforeseen events may occur.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Modification of Assessments
                                    </h4>

                                    <p className="">
                                        VOLT Learning reserves the right to:<br></br><br></br>
                                        <ul className="">
                                            <li className="">modify assessment content,</li>
                                            <li className="">change assessment format,</li>
                                            <li className="">revise eligibility criteria,</li>
                                            <li className="">update schedules,</li>
                                            <li className="">alter rewards or recognition,</li>
                                            <li className="">discontinue any assessment</li>
                                        </ul>
                                        without prior notice whenever necessary.
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Limitation of Liability
                                    </h4>

                                    <p className="">
                                        To the maximum extent permitted by law, VOLT Learning shall not be liable for any direct, indirect, incidental, or consequential loss arising from participation in the assessment or use of the platform.
                                    </p>

                                </div>

                            </div>

                        </div>
                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Suspension or Termination
                                    </h4>

                                    <p className="">
                                        VOLT Learning reserves the right to suspend or terminate any participant's access without refund if these Terms & Conditions are violated or if any fraudulent, abusive, or suspicious activity is detected.
                                    </p>

                                </div>

                            </div>

                        </div>
                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Governing Law
                                    </h4>

                                    <p className="">
                                        These Terms & Conditions shall be governed by the laws of India.
                                        Any disputes arising from participation shall be subject to the exclusive jurisdiction of the courts located in New Delhi, India.
                                    </p>

                                </div>

                            </div>

                        </div>
                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Limitation of Liability
                                    </h4>

                                    <p className="">
                                        VOLT Learning may revise these Terms & Conditions at any time. Continued use of the platform after such updates constitutes acceptance of the revised Terms.
                                    </p>

                                </div>

                            </div>

                        </div>
                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">



                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Contact Us
                                    </h4>

                                    <p className="">
                                        For any queries regarding these Terms & Conditions, please contact:<br></br>
                                        VOLT Learning<br></br>
                                        Email: <a href="mailto:info@voltlearning.in" className="">info@voltlearning.in</a><br></br>
                                        Website <a href="https://knowledgequest.voltlearning.in" className="">https://knowledgequest.voltlearning.in</a>
                                    </p>

                                </div>

                            </div>

                        </div>
                        <div class="terms-card mb-4">

                            <div class="d-flex align-items-start">
                                <div class="ms-3">

                                    <h4 class="terms-card-title mb-2">
                                        Additional Clauses I Strongly Recommend
                                    </h4>

                                    <p className="">
                                        These provide additional protection for your company and are often overlooked:<br></br><br></br>
                                        ✔ No Refund Policy<br></br>
                                        Registration fees are non-refundable except where VOLT Learning explicitly announces otherwise.<br></br><br></br>
                                        ✔ Decision of Organizer<br></br>
                                        The decision of VOLT Learning regarding eligibility, assessment administration, results, recognition, rewards, and interpretation of these Terms & Conditions shall be final and binding.<br></br><br></br>
                                        ✔ Right to Verify<br></br>
                                        VOLT Learning reserves the right to verify participant identity, school details, and eligibility at any stage. Failure to provide satisfactory verification may result in cancellation of participation or rewards.<br></br><br></br>
                                        ✔ Use of Images and Results<br></br>
                                        By participating, participants (or their parents/guardians, where applicable) consent to the use of their name, school name, photographs, videos, certificates, rankings, and achievements by VOLT Learning for educational, promotional, and publicity purposes without additional compensation, unless prohibited by applicable law.<br></br><br></br>
                                        ✔ Anti-Abuse Clause<br></br>
                                        Any attempt to disrupt the platform, misuse assessment content, reverse engineer the system, or engage in automated access, hacking, or malicious activity may result in permanent suspension and appropriate legal action.<br></br><br></br>
                                        These additional clauses significantly strengthen your legal position while remaining reasonable and appropriate for an educational platform.
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </section>
    )
}